import React, {
  useMemo,
  useState,
  useRef,
  useEffect,
  useCallback,
} from "react";
import {
  ChildrenBlock,
  defineBlock,
  useEditor,
} from "@smartfire/gutenberg-react";
import { Panel, PanelBody } from "@wordpress/components";
import { InnerBlocks } from "@wordpress/block-editor";
import { useSpring, animated } from "react-spring";
import style from "./block.module.scss";
import useMeasure from "../shared/useMeasure";

function DisplayCarousel() {
  const [current, setCurrent] = useState(0);
  const [bind, { width }] = useMeasure();
  const sliderRef = useRef();
  const slides = useRef();
  const props = useSpring({
    left: current * width * -1,
    width: width * (slides.current ? slides.current.length : 1),
  });

  function getSlides() {
    return sliderRef.current.querySelectorAll(
      'div[data-smartfire-type="Homehero"]'
    );
  }

  const next = useCallback(() => {
    if (current + 1 >= slides.current.length) {
      setCurrent(0);
    } else {
      setCurrent(current + 1);
    }
  }, [setCurrent, current, slides]);

  /* const previous = useCallback(() => {
        if(current - 1 < 0) {
            setCurrent(slides.current.length - 1);
        } else {
            setCurrent(current - 1);
        }
    }, [current, setCurrent, slides]);

    */

  const ready = slides.current;

  useEffect(() => {
    if (sliderRef.current) {
      slides.current = getSlides();
    }
  }, [sliderRef]);

  useEffect(() => {
    const t = setTimeout(() => next(), 7000);
    return () => clearTimeout(t);
  }, [current, next]);

  const dots = useMemo(() => {
    if (!ready || !slides.current) return [];
    const elems = [];
    for (let i = 0; i < slides.current.length; i++) {
      elems.push(
        <div
          key={i}
          className={i === current ? style.dotOn : style.dotOff}
          onClick={() => setCurrent(i)}
          alt={`Diapositive ${i + 1} est ${
            i === current ? "active" : "inactive"
          }`}
        />
      );
    }
    return elems;
  }, [current, slides, ready]);

  return (
    <div {...bind} className={style.carousel}>
      <animated.div
        style={{
          transform: props.left.interpolate((x) => `translateX(${x}px)`),
        }}
        className={style.slider}
        ref={sliderRef}
      >
        <ChildrenBlock />
      </animated.div>
      <div className={style.controls}>
        <div>{dots}</div>
      </div>
    </div>
  );
}

function HomeHeroCarousel() {
  const { isEditing } = useEditor();
  return (
    <div className={style.block}>
      {isEditing ? (
        <Panel header="Home Hero">
          <PanelBody title="Diapositives" icon="slides" initialOpen={true}>
            <InnerBlocks allowedBlocks={["smartfire/homehero"]} />
          </PanelBody>
        </Panel>
      ) : (
        <DisplayCarousel />
      )}
    </div>
  );
}

export default defineBlock({
  Block: HomeHeroCarousel,
  setup: {
    title: "Home Hero Slider",
    icon: "slides",
  },
});
